import * as queryString from "query-string/index";

// Adds affiliate, tracking, language and currency params to a partner deeplink.
// Returns the input unchanged when no partner rule matches.
export function rewriteDeeplink(deeplink, { lang, cur, attributor, cid }) {
  if (!deeplink) return deeplink;
  let link = deeplink;

  if (link.indexOf('rentalcars.com') > -1 || link.indexOf('cars.booking.com') > -1) {
    // rentalcars uses unique country lang br for pt-BR and pt for pt-PT
    const linkLang = lang.indexOf('pt') > -1 ? lang.substring(3, 2).toLowerCase() : lang.substring(0, 2)
    // link += `&adcamp=${attributor}&adplat=${cid}&preflang=${linkLang}&prefcurrency=${cur}`

    // starting Dec 2025 we work through TP
    // const rcLink = link + `&preflang=${linkLang}&prefcurrency=${cur}`
    // const rcTpLink = `https://tp.media/r?campaign_id=130&marker=422039&p=3814&sub_id=${attributor}-${cid}&trs=219900&u=${encodeURIComponent(rcLink)}`
    // car.booking.com link preflang=${linkLang}&prefcurrency=${cur}&selected_currency=${cur}
    const bookingLink = link.replace(/(www\.)*rentalcars\.com/i, 'cars.booking.com').replace(/\?.*/, `?preflang=${linkLang}`)
    return `https://tp.media/r?campaign_id=84&marker=422039&p=2076&sub_id=${attributor}-${cid}&trs=219900&u=${encodeURIComponent(bookingLink)}`

  } else if (link.indexOf('easycar.com') > -1) {
    const parsedUrl = queryString.parseUrl(link, { parseFragmentIdentifier: true });
    parsedUrl.query.campaign = attributor
    parsedUrl.query.clickref = cid
    // hack - the stringify behavior is to encode the "/" chars in the fragment, so I have to postfix the fragment manually
    link = queryString.stringifyUrl({ url: parsedUrl.url, query: parsedUrl.query });
    link += `#${parsedUrl.fragmentIdentifier}`
  } else if (link.indexOf('arguscarhire.com') > -1) {
    const parsedUrl = queryString.parseUrl(link, { parseFragmentIdentifier: true });
    parsedUrl.query.orderID = `${cid}-${attributor}`
    parsedUrl.query.curr = ['USD', 'EUR', 'GBP'].includes(cur) ? cur : 'EUR'; // for the moment we only allow USD, EUR & GBP due to bug in argus
    parsedUrl.query.lang = lang.substring(0, 2)
    // hack - the stringify behavior is to encode the "/" chars in the fragment, so I have to postfix the fragment manually
    link = queryString.stringifyUrl({ url: parsedUrl.url, query: parsedUrl.query });
    link += `#${parsedUrl.fragmentIdentifier}`
  } else if (link.indexOf('discovercars.com') > -1) {
    link = link.replace('discovercars.com/', `discovercars.com/${lang.substring(0, 2)}/`)
    link += `&data1=${cid}&data2=${attributor}`

    // hack - manipulate deeplink to travelpayouts
    // link = link.split('?')[0]
    // link = `https://tp.media/r?marker=422039.${cid}&trs=219900&p=3555&u=${encodeURIComponent(link)}&campaign_id=117`
    // } else if (link.indexOf('rent4less.co.il') > -1) {
    //   link += `&refId${getRandomInt(1,999)}=${cid}`
  } else if (link.indexOf('hertz.co.il') > -1) {
    if (lang.substring(0, 2) === 'en') { // hertz only support he and en. he comes from api by default
      link = link.replace('/he/', '/en/')
    }
  } else if (link.indexOf('barkro.com') > -1) {
    link += `&note=${cid}`
  } else if (link.indexOf('vipcars.com') > -1) {
    const parsedUrl = queryString.parseUrl(link, { parseFragmentIdentifier: true });
    parsedUrl.query.language = lang.substring(0, 2) == "he" ? "en" : lang.substring(0, 2); // vipcars he version sucks, so we set en for hebrew
    parsedUrl.query.currency = cur;
    parsedUrl.query.tid = `${attributor}-${cid}`;
    link = queryString.stringifyUrl({ url: parsedUrl.url, query: parsedUrl.query });
    if (parsedUrl.fragmentIdentifier) {
      link += `#${parsedUrl.fragmentIdentifier}`;
    }
  } else if (link.indexOf('qeeq.com') > -1) {
    let qeeqPreflang = 'en';
    if (['en', 'fr', 'it', 'de', 'es', 'pl'].includes(lang.substring(0, 2))) {
      qeeqPreflang = lang.substring(0, 2);
    } else if (lang === 'pt-BR') {
      qeeqPreflang = 'br';
    }
    const parsedUrl = queryString.parseUrl(link);
    parsedUrl.query.lang = qeeqPreflang;
    parsedUrl.query.currency = cur;
    const qeeqLink = queryString.stringifyUrl(parsedUrl);
    return `https://tp.media/r?campaign_id=172&marker=422039&p=4845&sub_id=${attributor}-${cid}&trs=219900&u=${encodeURIComponent(qeeqLink)}`
  }

  return link;
}

// Adds the browser's params to a links-service (/go) link so the service can forward them to the partner.
// Returns the input unchanged when it is empty or not an absolute URL.
export function rewriteLink(link, { lang, cur, residency, attributor, cid }) {
  if (!link) return link;
  let url;
  try {
    url = new URL(link);
  } catch (e) {
    return link;
  }
  if (lang) url.searchParams.set('lang', lang);
  if (cur) url.searchParams.set('cur', cur);
  if (residency) url.searchParams.set('res', residency);
  if (attributor) url.searchParams.set('utm_campaign', attributor);
  if (cid) url.searchParams.set('cid', cid);
  return url.toString();
}
